import { Navigate } from 'react-router-dom';

import type { FC, ReactNode } from 'react';

import LoadingCover from '@/components/Layouts/Loading';
import { useMcpMemberFlag } from '@/hooks/useMcpMemberFlag';

// UX guard only: Moments enforces mcp+member on every RPC and on /mcp.
const McpMemberRoute: FC<{ children: ReactNode }> = ({ children }) => {
  const { enabled, isLoading } = useMcpMemberFlag();
  if (isLoading) {
    return <LoadingCover />;
  }
  if (!enabled) {
    return <Navigate to="/m" replace />;
  }
  return children;
};

export default McpMemberRoute;
